module.exports = __webpack_public_path__ + "img/mariners.5a18ab4a.svg";